import React, { useContext } from 'react';
import { path } from 'ramda';
import { BrandConfigContext } from '@low/containers/brand-config/brand-config-context';
import { BrandConfigSourceType } from '@low/dynamic/types';
import rwcInternalApi, { intApiBrandConfig } from '@ringcentral/rwc-utils/src/internal-api';

// In hercules mode, some ui components are seperated from main app(such as setting modal),which are not wrapped by BrandConfigProvider
// can not get final brand config,
// we need to get brand config from rwcInternalApi[intApiBrandConfig]
const getFinalBrandConfig = brandConfig =>
    [brandConfig, rwcInternalApi?.[intApiBrandConfig]].find(
        item => item?.source !== BrandConfigSourceType.INIT
    ) ?? brandConfig;

export const useBrandConfig = () => {
    const contexts = useContext(BrandConfigContext);
    return brandConfigKey => path(brandConfigKey, getFinalBrandConfig(contexts?.brandConfig));
};

export function withBrandConfig(Component) {
    return function brandComponent(props) {
        return (
            <BrandConfigContext.Consumer>
                {contexts => (
                    <Component
                        {...props}
                        getBrandConfig={brandConfigKey =>
                            path(brandConfigKey, getFinalBrandConfig(contexts?.brandConfig))
                        }
                    />
                )}
            </BrandConfigContext.Consumer>
        );
    };
}
